import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkodaComponent } from './simple-icons-skoda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkodaComponent ],
    exports:      [ SimpleIconsSkodaComponent ],
    bootstrap:    []
})
export class SimpleIconsSkodaModule {}
